module.exports = __webpack_public_path__ + "img/60exp.37194f07.jpg";